import { Copy } from '@stokr/components-library'
import { Section } from 'components/sto/Section'
import { useBorrow } from 'hooks/sto/useBorrow'
import { LoanCalculator } from './LoanCalculator'

/** The funds' loan calculator, as its own section. */
export const Borrow = () => {
  const state = useBorrow()

  return (
    <Section anchor="borrow" title={<Copy id="stoPage.borrow.title" />} state={state} collapsible="always">
      {() => <LoanCalculator />}
    </Section>
  )
}
